import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {Button} from 'reactstrap';
import {gAChangePPOpenPlansForLimited} from '../reports/gaReports';

const SubscriberItemWithButtonComponent = (props) => {
  const {account, activateSelecting, showCurrentPackage} = props;

  const activateSelectingClick = () => {
    gAChangePPOpenPlansForLimited();
    activateSelecting(account);
  };

  return (
    <div className='subscriber-item-with-button'>
      <div className='subscriber-item-number bold text-right'>
        <div>מנוי {account.subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2')}</div>
        <div>
          <Button color='link' className='pink-text back-link pr-0' onClick={() => showCurrentPackage(account.subscriberNo, false)}>
            לצפייה בחבילה הנוכחית
          </Button>
        </div>
      </div>

      <BtnSubmit text='עדכון חבילה' onclick={() => activateSelectingClick()} />
    </div>
  );
};

export default SubscriberItemWithButtonComponent;
